import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { get } from "lodash";
import { useHistory } from "react-router-dom";

function ProfilePg(props) {
  const [formData, setName] = useState({
    first: "",
    last: "",
    email: "",
    phone: "",
    addr: "",
    PWD: "",
  });
  const navigate = useHistory();
  const imagepath = `${process.env.REACT_APP_API_URL}/GetImage`;

  useEffect(() => {
    LoadUser();
  }, []);

  const LoadUser = () => {
    const datavalue = {
      role: "Admin",
    };
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/getProfileByRole`,
      data: JSON.stringify(datavalue),
      headers: { "Content-Type": "application/json" },
    };
    axios(authOptions)
      // axios.post(`https://localhost:7261/getIntentsByid`, datavalue, config)
      .then((res) => {
        //console.log("get value", res);
        //console.log("list", res.data.result[0].firstname)
        // setIntentList(res.data)
        // "firstname":"md","lastname":"gdff","emailid":"dfdf","phone":"465456465","address":"fdsfdfsd"}
        setName({
          first: res.data.result[0].firstname,
          last: res.data.result[0].lastname,
          email: res.data.result[0].emailid,
          phone: res.data.result[0].phone,
          addr: res.data.result[0].address,
          PWD: res.data.result[0].password,
        });
      });
  };

  const onUpload = (event) => {
    // UploadImage
    // userActions.uploadFile(token, get(event, 'target.files[0]')).then(res => {
    //console.log("upload", get(event, 'target.files[0]'))

    const imagevalue = {
      formFile: get(event, "target.files[0]"),
    };

    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/UploadImage`,
      data: imagevalue,
      headers: { "Content-Type": "multipart/form-data" },
    };
    axios(authOptions).then((res) => {
      //console.log("save msg", res)
      window.location.reload(true);
      // navigate.push('/');
    });
  };
  const updatesubmit = async (e) => {
    e.preventDefault();

    //console.log("formData", formData)

    let formDataSet = new FormData();
    //formdata object
    if (
      formData.first === "" ||
      formData.last === "" ||
      formData.email === "" ||
      formData.phone === "" ||
      formData.addr === ""
    ) {
      if (formData.first === "") {
        Swal.fire({
          title: "Error",
          text: "First name Field Is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      } else if (formData.last === "") {
        Swal.fire({
          title: "Error",
          text: "Last Name Field Is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      } else {
        Swal.fire({
          title: "Error",
          text: "Email Field Is Required",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
    } else {
      formDataSet.append("firstname", formData.first); //append the values with key, value pair
      formDataSet.append("lastname", formData.last);
      formDataSet.append("emailid", formData.email);
      formDataSet.append("phone", formData.phone);
      formDataSet.append("address", formData.addr);
      formDataSet.append("password", formData.PWD);

      // //console.log("formdata", formDataSet)
      // formDataSet.append('id', IntId);

      // const config = {
      //     headers: { 'content-type': 'multipart/form-data' }
      // }
      var authOptions = {
        method: "post",
        url: `${process.env.REACT_APP_API_URL}/updateProfile`,
        data: formDataSet,
        headers: { "Content-Type": "multipart/form-data" },
      };
      axios(authOptions)
        .then((res) => {
          //console.log("get value", res);

          //console.log("success")
          // setName({ intents: "", Ans1: "", Ans2: "" });
          Swal.fire({
            title: "Success",
            text: "Profile Update Successfully",
            icon: "success",
            confirmButtonText: "Ok",
          }).then(function () {
            // window.location.pathname = "/patient-ai/IntentList";
            // LoadUser();
            window.location.reload(true);
            // navigate.push('/');
          });
        })
        .catch((error) => {
          //console.log("error occur", error);
        });
    }
  };

  const handleChange = (e) => {
    setName({ ...formData, [e.target.name]: e.target.value });
  };

  const canclebtn = () => {
    navigate.push("/");
  };

  return (
    <>
      <div className="page-content-wrapper">
        <div className="page-content">
          <div className="page-bar">
            <div className="page-title-breadcrumb">
              <div className=" pull-left">
                <div className="page-title my-0">Update Profile</div>
              </div>
              {/* <div className=" pull-right">
                                <button type="submit" className="btn btn-primary d-inline-block" onClick={BackFunc}> <i className="fa fa-arrow-left" aria-hidden="true"></i></button>
                            </div> */}
            </div>
          </div>
          <div className="row">
            {/* <div className='col-md-3'>

                      </div> */}

            <div className="col-md-12 col-sm-12">
              <div className="card card-box">
                <div className="card-head">
                  <header>Profile</header>
                </div>
                <div className="card-body " id="bar-parent1">
                  {/* <form className="form-horizontal"> */}
                  <form
                    className="register-form"
                    id="login-form"
                    onSubmit={updatesubmit}
                  >
                    <div className="form-group">
                      <div className="row">
                        <div className="col-12 col-md-6">
                          <label
                            for="horizontalFormEmail"
                            className="control-label"
                          >
                            First Name
                          </label>
                          <input
                            type="text"
                            value={formData.first}
                            onChange={handleChange}
                            name="first"
                            className="form-control"
                            id="simpleFormEmail"
                            placeholder="First Name"
                          />
                        </div>
                        <div className="col-12 col-md-6">
                          <label
                            for="horizontalFormEmail"
                            className="control-label"
                          >
                            Last Name
                          </label>

                          {/* <input type="text" className="form-control" id="horizontalFormEmail"
                                                        placeholder="Last Name" /> */}
                          <input
                            type="text"
                            value={formData.last}
                            onChange={handleChange}
                            name="last"
                            className="form-control"
                            id="simpleFormEmail"
                            placeholder="Last Name"
                          />
                        </div>
                        <div className="col-12 col-md-6">
                          <label
                            for="horizontalFormEmail"
                            className="control-label"
                          >
                            Email
                          </label>
                          <input
                            type="email"
                            value={formData.email}
                            onChange={handleChange}
                            name="email"
                            className="form-control"
                            id="simpleFormEmail"
                            placeholder="Email"
                          />
                        </div>
                        <div className="col-12 col-md-6">
                          <label
                            for="horizontalFormEmail"
                            className="control-label"
                          >
                            Phone no.
                          </label>
                          <input
                            type="number"
                            value={formData.phone}
                            onChange={handleChange}
                            name="phone"
                            className="form-control"
                            id="simpleFormEmail"
                            placeholder="Phone No."
                          />
                        </div>
                        <div className="col-12 col-md-6">
                          <label
                            for="horizontalFormEmail"
                            className="control-label"
                          >
                            Password
                          </label>
                          <input
                            type="text"
                            value={formData.PWD}
                            onChange={handleChange}
                            name="PWD"
                            className="form-control"
                            id="simpleFormEmail"
                            placeholder="Password"
                          />
                        </div>
                        <div className="col-12 col-md-6">
                          <label
                            for="horizontalFormEmail"
                            className=" control-label"
                          >
                            Organization
                          </label>

                          <input
                            type="text"
                            value={formData.org}
                            onChange={handleChange}
                            name="org"
                            className="form-control"
                            id="simpleFormEmail"
                            placeholder="Organizattion"
                          />
                        </div>
                        <div className="col-12 col-md-6">
                          <label
                            for="horizontalFormPassword"
                            className="col-sm-2 control-label"
                          >
                            Address
                          </label>
                          <textarea
                            type="text"
                            value={formData.addr}
                            onChange={handleChange}
                            name="addr"
                            className="form-control"
                            id="simpleFormEmail"
                            placeholder="Adress"
                          />
                        </div>
                        <div className="col-12 col-md-6">
                          <label
                            for="horizontalFormPassword"
                            className="col-12 control-label"
                          >
                            User Image
                          </label>
                          <div className="col-12">
                            <div className="row">
                              <div className="col-2">
                                <img
                                  src={imagepath}
                                  style={{ width: "50px" }}
                                  alt="new"
                                />
                              </div>
                              <div className="col-10">
                                <div
                                  className="photoEdit mt-3"
                                  style={{ position: "relative" }}
                                >
                                  <input
                                    type="file"
                                    onChange={onUpload}
                                    id="myFile"
                                    name="filename"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-md-6">
                          <button
                            type="submit"
                            className="btn btn-info m-r-20 d-inline-block mt-4"
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="form-group">
                      <div className="offset-md-3 col-md-9">
                        <div className="col-12 text-end">
                          {/* <button type="button" className="btn btn-default d-inline-block" onClick={canclebtn}>Cancel</button> */}
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProfilePg;
